/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OuterQuantityDetails } from '../../models/outer-quantity-details';

export interface GetOuterViewQuantityDetails$Params {
  productionOrderId: number;
}

export function getOuterViewQuantityDetails(http: HttpClient, rootUrl: string, params: GetOuterViewQuantityDetails$Params, context?: HttpContext): Observable<StrictHttpResponse<OuterQuantityDetails>> {
  const rb = new RequestBuilder(rootUrl, getOuterViewQuantityDetails.PATH, 'get');
  if (params) {
    rb.path('productionOrderId', params.productionOrderId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<OuterQuantityDetails>;
    })
  );
}

getOuterViewQuantityDetails.PATH = '/api/v1/ProductionOrder/{productionOrderId}/GetOuterViewQuantityDetails';
